import { render, staticRenderFns } from "./AllPackages.vue?vue&type=template&id=05a34c88&scoped=true&"
import script from "./AllPackages.vue?vue&type=script&lang=js&"
export * from "./AllPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a34c88",
  null
  
)

export default component.exports